<template>
    <Card class="settings-mandate">
        <div class="settings-mandate__header">
            <h2 class="typographies-heading-h2 settings-mandate__title">
                {{ $t.__('settings.mandate.title') }}
            </h2>
            <CompassLink
                :label="$t.__('common.actions.view_faq')"
                link="https://help.sellsy.com/fr/articles/12674837-completer-le-mandat-d-emission-et-de-reception-sur-la-plateforme-sellsy-pa"
                target="_blank"
                prefixIcon="help-circle-fill"
            />
        </div>
        <p class="typographies-paragraph-medium-regular settings-mandate__description">
            {{ $t.__('settings.mandate.description') }}
        </p>

        <div v-if="isLoading" class="settings-mandate__loading-state">
            <CompassLoader size="large" />
            <p class="typographies-paragraph-medium-regular">
                {{ $t.__('settings.mandate.loading_message') }}
            </p>
        </div>
        <template v-else>
            <CompassEmptyState
                v-if="!mandates.length"
                :title="$t.__('settings.mandate.empty_state.title')"
                illustrationPath="/ressources/logged/img/illustrations/pdp/document-signature.svg"
            >
                <CompassButton
                    :label="$t.__('settings.mandate.empty_state.button')"
                    @click="handleCompleteMandate"
                />
            </CompassEmptyState>
            <template v-else>
                <h3 class="typographies-heading-h3 settings-mandate__sub-title">
                    {{ $t.__('settings.mandate.list.title') }}
                </h3>
                <div class="settings-mandate__list">
                    <MandateItem
                        v-for="mandate in mandates"
                        :key="mandate.id"
                        :mandate="mandate"
                        @mandateDeleted="getMandates"
                    />
                </div>
                <div class="settings-mandate__footer">
                    <p class="typographies-paragraph-medium-regular">
                        {{ $t.__('settings.mandate.siren_change') }}
                    </p>
                    <CompassButton
                        :label="$t.__('settings.mandate.new_mandate')"
                        type="secondary"
                        :disabled="isDisabled"
                        @click="createNewMandate"
                    />
                </div>
            </template>
        </template>
    </Card>
</template>
<script>
import Card from 'vcomponents/common/card/Card.vue';
import MandateItem from 'vcomponents/settings/mandate/MandateItem.vue';
import { getEInvoicingMandate } from 'api/mandate';
export default {
    components: {
        Card,
        MandateItem,
    },
    data() {
        return {
            mandates: [],
            isLoading: false,
        };
    },
    computed: {
        isDisabled() {
            return (
                this.mandates.length > 1 ||
                this.mandates[0].types.includes('receipt') ||
                this.mandates[0].status === 'pending'
            );
        },
    },
    created() {
        this.getMandates();
    },
    methods: {
        handleCompleteMandate() {
            this.$router.push({ name: 'pa.mandate.onboarding' });
        },
        getMandates() {
            this.isLoading = true;
            getEInvoicingMandate()
                .then((response) => {
                    this.mandates = response.data;
                })
                .catch((error) => {
                    if (error.response.status !== 404) {
                        this.$pushToast({
                            type: 'error',
                            icon: true,
                            text: this.$t.__('settings.mandate.fetch_error'),
                        });
                    } else {
                        this.mandates = [];
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        createNewMandate() {
            this.$router.push({ name: 'pa.mandate.onboarding' });
        },
    },
};
</script>
<style lang="scss" scoped>
.settings-mandate {
    &__header {
        display: flex;
        gap: var(--spacing-3);
        justify-content: space-between;
        margin: 0 0 var(--spacing-3);
    }

    &__title {
        margin: 0;
    }

    &__sub-title {
        margin: 0 0 var(--spacing-1);
    }

    &__description {
        margin: 0 0 var(--spacing-4);
    }

    &__loading-state {
        align-items: center;
        color: var(--colors-common-text-subtle-default);
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
        padding: var(--spacing-5) 0;

        p {
            margin: 0;
        }
    }

    &__footer {
        border-top: 1px solid var(--colors-common-border-default);
        margin: var(--spacing-5) 0 0;
        padding: var(--spacing-5) 0 0;

        p {
            margin: 0 0 var(--spacing-3);
        }
    }
}
</style>
